module.exports = __webpack_public_path__ + "041bb045941a2c1fd71bc59c8ad65773.svg";